import React from 'react';
import './PageHeader.css';

function PageHeader(props) {
    return (
        <div className="PageHeader"></div>
    )
}

export default PageHeader;